export class ChoosesListShow {
    constructor(optionalOptions = {}) {
        this._block = document.querySelector('.menu-list--chooses');

        if (!this._block) {
            this.destructor();
            return true;
        }

        let section = document.querySelectorAll('.menu-list--group');
        let lists = document.querySelectorAll('.menu-list-chooses--li');

        function _isMobile() {
            let _laptopXs = '985';

            let _width = window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth;

            let _isMobileAttr = false;
            if (_width <= _laptopXs) {
                _isMobileAttr = true;
            }

            return _isMobileAttr;
        }

        function activeLink(li) {
            lists.forEach((item) => item.classList.remove('active'));
            li.classList.add('active');
        }

        lists.forEach((item) =>
            item.addEventListener('click', function(){
                activeLink(this);
            }));

        let searchBlock = document.querySelector('.menu-list--search');
        let searchField = searchBlock.querySelector('.base-input-wrp--search');
        let headerTitle = document.querySelector('.header-top--title');

        if (!_isMobile()) {
            if (!headerTitle.querySelector('.base-input-wrp--search')) {
                let clone = searchField.cloneNode(true);
                clone.style.height = "36px";
                clone.style.width = (headerTitle.offsetWidth - 16) + "px";
                headerTitle.innerHTML = '';
                headerTitle.appendChild(clone);
            }

            this._block.classList.add('show');
        }

        window.onscroll = () => {
            let top = window.scrollY;

            if (_isMobile()) {
                if (top >= searchBlock.offsetTop + 20) {
                    if (!headerTitle.querySelector('.base-input-wrp--search')) {
                        let clone = searchField.cloneNode(true);
                        clone.style.height = "36px";
                        clone.style.width = (headerTitle.offsetWidth - 16) + "px";
                        headerTitle.innerHTML = '';
                        headerTitle.appendChild(clone);
                    }
                } else {
                    headerTitle.innerHTML = headerTitle.dataset.title;
                }
            }

            if (_isMobile()) {
                if (top >= section[0].offsetTop) {
                    this._block.classList.add('show');
                } else {
                    this._block.classList.remove('show');
                }
            }

            section.forEach(sec => {
                let offset = sec.offsetTop;
                let height = sec.offsetHeight;

                let id = sec.getAttribute('id');
                if (top >= offset && top < offset + height) {
                    const target = document.querySelector(`[href='#${id}']`).parentElement;
                    activeLink(target);
                }
            })
        };
    }

    destructor() {
        this._block = null;
    }
}

export default new ChoosesListShow();